import axiosInstance from './axiosInstance';

const todoService = {
  getTodos: () => {
    return axiosInstance.get('/todos');
  },
  createTodo: (todoData) => {
    return axiosInstance.post('/todos', todoData);
  },
  updateTodo: (id, todoData) => {
    return axiosInstance.put(`/todos/${id}`, todoData);
  },
  deleteTodo: (id) => {
    return axiosInstance.delete(`/todos/${id}`);
  },
  deleteCheckedTodos: () => {
    return axiosInstance.delete('/todos/checked');
  },
  toggleAllTodos: (checked, e) => {
    console.log('체크드 ',checked)
    console.log('전체 ',e)
    return axiosInstance.put(`/todos/toggle-all/${checked}`);
  },
};

export default todoService;
